import { render, staticRenderFns } from "./NaviTopComponent.vue?vue&type=template&id=37401848"
import script from "./NaviTopComponent.vue?vue&type=script&lang=js"
export * from "./NaviTopComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports